import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'Give the Gift of Stress-Free Golf Travel | ShipSticks',
  description:
    'Perfect for birthdays, holidays, or just because, ShipSticks gift cards are the ' +
    'ultimate gift for golfers on the go.',
  alternates: {
    canonical: 'https://www.shipsticks.com/gift-cards',
  },
}

export default metadata
